"use client";

import React, { createContext, useCallback, useContext, useState } from "react";

import GetFreeAssessmentModal from "./GetFreeAssessmentModal";

interface GetFreeAssessmentModalContextValue {
  openModal: () => void;
  recipientEmail?: string;
}

const GetFreeAssessmentModalContext =
  createContext<GetFreeAssessmentModalContextValue | null>(null);

export function useGetFreeAssessmentModal() {
  return useContext(GetFreeAssessmentModalContext);
}

interface GetFreeAssessmentModalProviderProps {
  children: React.ReactNode;
  recipientEmail?: string;
}

export function GetFreeAssessmentModalProvider({
  children,
  recipientEmail,
}: GetFreeAssessmentModalProviderProps) {
  const [open, setOpen] = useState(false);
  const openModal = useCallback(() => setOpen(true), []);

  return (
    <GetFreeAssessmentModalContext.Provider
      value={{ openModal, recipientEmail }}
    >
      {children}
      <GetFreeAssessmentModal
        open={open}
        onOpenChange={setOpen}
        recipientEmail={recipientEmail}
      />
    </GetFreeAssessmentModalContext.Provider>
  );
}
